import { Box } from "@nulogy/components";
import React from "react";

export default function PageDescription({ description }) {
  return (
    <Box color="darkGrey" marginBottom="x3" maxWidth="672px">
      {description}
    </Box>
  );
}
